import { render, staticRenderFns } from "./customLabel.vue?vue&type=template&id=6515fb41&scoped=true&"
import script from "./customLabel.js?vue&type=script&lang=js&"
export * from "./customLabel.js?vue&type=script&lang=js&"
import style0 from "./customLabel.vue?vue&type=style&index=0&id=6515fb41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515fb41",
  null
  
)

export default component.exports